export const IS_IFRAME = "IS_IFRAME";
export const IS_NESTEDGRID = "IS_NESTEDGRID";
export const TOGGLE_IFRAME = "TOGGLE_IFRAME";
export const CHANGE_MODEL = "CHANGE_MODEL";

export function isIframe(path) {
  return { type: IS_IFRAME, path };
}
export function toggleIframe(path, nestedGrid) {
  return { type: TOGGLE_IFRAME, path, nestedGrid };
}
export function isNestedGrid(nestedGrid) {
  return { type: IS_NESTEDGRID, nestedGrid };
}
export function changeModel(val) {
  return { type: CHANGE_MODEL, val };
}